import { render, staticRenderFns } from "./ModalPin.vue?vue&type=template&id=befc1edc&scoped=true"
import script from "./ModalPin.vue?vue&type=script&lang=js"
export * from "./ModalPin.vue?vue&type=script&lang=js"
import style0 from "./ModalPin.vue?vue&type=style&index=0&id=befc1edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befc1edc",
  null
  
)

export default component.exports